export default __webpack_public_path__ + "static/media/FiguradoOpen.5f3f6321.jpg";